import { render, staticRenderFns } from "./TestTransection.vue?vue&type=template&id=3aea1cc3&scoped=true&"
import script from "./TestTransection.vue?vue&type=script&lang=js&"
export * from "./TestTransection.vue?vue&type=script&lang=js&"
import style0 from "./TestTransection.vue?vue&type=style&index=0&id=3aea1cc3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3aea1cc3",
  null
  
)

export default component.exports